import Order from "./Order.js";
export default class TruckTop {
    constructor(canvas, ctx, allPallets, truck, divider, orders) {
        this.canvas = canvas;
        this.ctx = ctx;
        this.allPallets = allPallets;
        this.truck = truck;
        this.divider = divider;
        this.orders = orders;
        this.onMouseMove = event => {
            this.drag(event);
        };
        this.onMouseUp = () => {
            this.drop();
        };
        this.colors = [
            "#B5E61D",
            "#FFF200",
            "#99D9EA",
            "#FFAEC9",
            "#FF7F27",
            "#C8BFE7",
            "#00A2E8",
            "#22B14C",
            "#B5E61D",
            "#FFF200",
            "#99D9EA",
            "#FFAEC9",
            "#FF7F27",
            "#C8BFE7",
            "#00A2E8",
            "#22B14C",
            "#B5E61D",
            "#FFF200",
            "#99D9EA",
            "#FFAEC9",
            "#FF7F27",
            "#C8BFE7",
            "#00A2E8",
            "#22B14C"
          ];
          this.draw();
    }

    updateCanvas(){
        this.canvas.width = this.truck.getLength();
        this.canvas.height = this.truck.width;
        this.draw();
    }

    draw() {
        const orders = Order.sortByPalletPriority(this.truck, this.orders);
        this.ctx.fillStyle = this.truck.palletsFit() ? "rgb(99, 99, 91)" : "red";
        this.ctx.fillRect(0, 0, this.canvas.width, this.truck.width); //draw rectangles
        this.ctx.strokeStyle = "rgb(0,0,0)";
        this.truck.pallets.forEach(pallet => {
            this.ctx.fillStyle = "rgb(233, 215, 159)";
            const x = pallet.truck_x;
            const y = pallet.truck_y;
            let width = pallet.getLength();
            let height = pallet.getWidth();
            if (pallet.is_turned) {
                width = pallet.width;
                height = pallet.length;
            }
            if (pallet.status >= 3) {
                this.ctx.fillStyle = "rgb(152, 209, 160)";
            }
            if (pallet.getLength() + pallet.truck_x > this.truck.length || pallet.getHeight() > this.truck.height) {
                this.ctx.fillStyle = "red";
            }
            if (!pallet.searched) {
                this.ctx.fillStyle = "rgb(207, 207, 207)";
              }
            this.ctx.fillRect(x, y, width, height); //draw rectangles
            //get color to match the one on selector
            this.ctx.fillStyle = pallet.getDispatchColor(orders, this.colors, this.truck.company_id);
            const innerDelimeter = 200 / this.divider;
            if (pallet.searched) {
                this.ctx.fillRect(x + innerDelimeter, y + innerDelimeter, width - innerDelimeter, height - innerDelimeter); // draw inner rectangle with matching color
            }
            this.ctx.strokeRect(x, y, width, height); //draw borders
            this.drawPalletText(this.ctx, pallet, x, y, Math.round(width * this.truck.divider), Math.round(height * this.truck.divider)); // draw text
        });
    }

    drawPalletText(ctx, pallet, x, y, width, height) {
        ctx.font = `${120 / this.divider}px Arial`;
        ctx.fillStyle = "rgb(0,0,0)";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
      
        const lengthTextX = x + pallet.length / 2;
        const lengthTextY = y + 100 / this.divider;
        ctx.fillText(width, lengthTextX, lengthTextY);
      
        const widthTextX = x + 100 / this.divider;
        const widthTextY = y + pallet.width / 2;
        ctx.save();
        ctx.translate(widthTextX, widthTextY);
        ctx.rotate(-Math.PI / 2);
        ctx.fillText(height, 0, 0); //truck width text
        ctx.restore();
        ctx.textAlign = "left";
        const contentX = x + 200 / this.divider;
        let contentY = y + 300 / this.divider;
        const palletIndex = `#${this.allPallets.map(pallet => { return pallet.id}).indexOf(pallet.id) + 1}`;
        const palletNumber = pallet.getNumber() != "" ? pallet.getNumber() : palletIndex;
        ctx.fillText(palletNumber, contentX, contentY); //truck width text
        let orders = pallet.getOrdersFromNumber();
        orders.forEach(order => {
          const orderTexts = order.split(" ");
          contentY += 200 / this.divider;
          ctx.fillText(orderTexts[0], contentX, contentY);
        });
      }

    grab(event) {
        if(this.truck.status >= 4) return;
        this.selectedPallet = this.truck.overPallet(event);
        if (this.selectedPallet != null) {
            document.dispatchEvent(new Event('dragStart'));
            this.mouseOffset = {
                left: event.clientX - this.selectedPallet.truck_x,
                top: event.clientY - this.selectedPallet.truck_y
            };
            this.mouseMovedHandler = this.onMouseMove.bind(this);
            this.mouseUpHandler = this.onMouseUp.bind(this);
            document.body.addEventListener("mousemove", this.mouseMovedHandler);
            document.body.addEventListener("mouseup", this.mouseUpHandler);
        }
    }

    drag(event) {
        this.selectedPallet.truck_x = Math.round(event.clientX - this.mouseOffset.left);
        this.selectedPallet.truck_y = Math.round(event.clientY - this.mouseOffset.top);
        this.draw();

    }

    async drop() {
        this.updateCanvas();
        document.body.removeEventListener("mousemove", this.mouseMovedHandler);
        document.body.removeEventListener("mouseup", this.mouseUpHandler);
        document.dispatchEvent(new Event("moved"));
        document.dispatchEvent(new Event("dropped"));
    }

}